import React from 'react';
import { Users, Calendar, Menu, House, CheckSquare } from 'lucide-react';

export default function BottomNav({ activeMenu, setActiveMenu, onOpenMenu }) {
  const navItems = [
    { id: 'dashboard', label: '홈', icon: House },
    { id: 'students', label: '명단', icon: Users },
    { id: 'attendance', label: '출석', icon: CheckSquare },
    { id: 'schedule', label: '캘린더', icon: Calendar },
  ];

  const baseButtonClass = "flex flex-col items-center justify-center w-full h-full space-y-0.5 transition-colors";
  const activeButtonClass = "text-[#354F38]";
  const inactiveButtonClass = "text-gray-400 active:text-gray-600";

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 flex justify-around items-center z-50 md:hidden pb-safe px-2 h-[88px] shadow-[0_-5px_20px_rgba(0,0,0,0.02)]">
      {navItems.map((item) => (
        <button
          key={item.id}
          onClick={() => setActiveMenu(item.id)}
          aria-current={activeMenu === item.id ? "page" : undefined}
          aria-label={item.label}
          className={`${baseButtonClass} ${activeMenu === item.id ? activeButtonClass : inactiveButtonClass}`}
        >
          <item.icon
            size={24}
            strokeWidth={activeMenu === item.id ? 2.5 : 2}
            className={`transition-all duration-300 ${activeMenu === item.id ? "scale-110 -translate-y-0.5" : ""}`}
          />
          <span
            className={`text-[10px] font-bold leading-none transition-all duration-300 ${
              activeMenu === item.id ? "opacity-100" : "opacity-80"
            }`}
          >
            {item.label}
          </span>
        </button>
      ))}

      {/* Menu Button (5th Tab) */}
      <button
        onClick={onOpenMenu}
        aria-label="메뉴"
        className={`${baseButtonClass} ${inactiveButtonClass}`}
      >
        <Menu size={24} strokeWidth={2} />
        <span className="text-[10px] font-bold leading-none opacity-80">메뉴</span>
      </button>
    </nav>
  );
}
